<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.10777 4.62002C10.2238 3.50402 11.5654 2.94482 13.1326 2.94482C14.6998 2.94482 16.0414 3.50402 17.1574 4.62002C18.2734 5.73602 18.8326 7.07762 18.8326 8.64482V11.8152V14.3448V21.1848H5.90137V11.8176H17.3014V8.64722C17.3014 7.48322 16.8982 6.49922 16.0894 5.69042C15.2806 4.88402 14.2966 4.47842 13.1326 4.47842C11.9686 4.47842 10.9822 4.88162 10.1758 5.69042C9.36697 6.49922 8.96377 7.48322 8.96377 8.64722V9.39602H7.43257V8.64722C7.43257 7.08002 7.98937 5.73842 9.10777 4.62002ZM17.3014 19.6536V14.3472V13.3488H7.43257V19.6536H17.3014Z"
      class="fill-current"
    />
  </svg>
</template>
